import { useMutation } from "@tanstack/react-query";

import UserService from "../../../service/UserService";

const validateLogin = async ({ url, username, password }) => {
  const response = await UserService.validateWordpressLogin({ url, username, password });

  return response;
};

export default function useValidateWordpressLogin() {
  const mutation = useMutation({ mutationFn: validateLogin });

  // mutate reports failures through isError and options.onError; it never throws.
  const run = ({ url, username, password }, options) =>
    mutation.mutate({ url, username, password }, options);

  const { isPending, isError, error } = mutation;
  return [run, { isPending, isError, error }];
}
